import React from 'react';

import CoproVigilance from '../../components/Analyzing/CoproVigilance';

function CoproVigilanceView() {
  return (
    <CoproVigilance />
  );
}

export default CoproVigilanceView;
